module.exports = __webpack_public_path__ + "img/logo-company.4383dce8.png";